import React from "react";
import "./About.css";
import aboutImg from "./img/About-min.jpg";
function About() {
	//  Up To Top Btn
	window.addEventListener("scroll", function () {
		const upToTop = document.querySelector("a.bottom__to__top");
		upToTop.classList.toggle("active", window.scrollY > 0);
	});
	return (
		<div
			className="about component__space"
			id="About"
		>
			<div className="container about">
				<div className="row about reverse">
					<div className="col__2">
						<img
							src={aboutImg}
							alt=""
							className="about__img"
						/>
					</div>
					<div className="col__2">
						<h1 className="motto__heading left">
							Supercharge vitality <br /> by increasing your <br />
							knowledge and activity
						</h1>
						<br />
						<h1 className="about__heading motto__heading left">Meet Marina</h1>
						<br />
						<div className="about__meta">
							<p className="about__text p__color">
								Her outlook on fitness and wellbeing is focused on balance
								between strength and mobility, optimal nutrition, and
								mindfulness with every step of the way.
								<br />
							</p>

							<p className="about__text p__color">
								Marina looks at the body as a complex system that needs to be
								addressed accordingly. We are multidimensional, incredibly
								complex, non linear and not all sizes fit beings
							</p>
							<div
								className="about__button d__flex align__items__center"
								style={{ gap: 30 }}
							>
								<a
									href="https://docs.google.com/forms/d/1E257IEXU7Nf48yiMpXjr9B8p1VNRMdQ1WFuh4AX1-mw"
									target="_blank"
									rel="noopener noreferrer"
								>
									<button className="button__primary btn pointer">
										COACHING APPLICATION
									</button>
								</a>

								{/* <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/tqxNT6nlUG8?si=kWe0y9pwRfxgk2Cl"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe> */}
							</div>
							<button className="button__primary btn pointer">
								WELLNESS RETREATS
							</button>
						</div>
					</div>
				</div>
			</div>
			{/* UP TO TOP BTN */}
			<div className="up__to__top__btn">
				<a
					href="#"
					className="bottom__to__top"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						fill="currentColor"
						class="bi bi-chevron-up white"
						viewBox="0 0 16 16"
					>
						<path
							fill-rule="evenodd"
							d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
						/>
					</svg>
				</a>
			</div>
		</div>
	);
}

export default About;
